import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const rootElement = document.getElementById('root');
const app = <React.StrictMode><App /></React.StrictMode>;

try {
  ReactDOM.createRoot(rootElement).render(app);
} catch (e) {
  console.error('[QMS] Failed to start app:', e);
  rootElement.innerHTML = [
    '<div style="min-height:100vh;background:#0a1628;color:#fff;display:flex;align-items:center;justify-content:center;padding:40px;text-align:center;font-family:sans-serif">',
    '<div><h1 style="margin:0 0 12px">QMS Display</h1>',
    '<p style="opacity:0.75;max-width:520px;line-height:1.5">This TV browser is too old to run the display app. Install <strong>Fully Kiosk Browser</strong> or <strong>TV Bro</strong> from the Play Store and open the display URL there.</p>',
    '</div></div>',
  ].join('');
}
